import { render, staticRenderFns } from "./wtPlayerAudio.component.vue?vue&type=template&id=7c8551fc&"
import script from "./wtPlayerAudio.component.vue?vue&type=script&lang=js&"
export * from "./wtPlayerAudio.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports